import React, { SVGProps } from 'react';

const UserIcon = ({
  className,
  fill = '#777',
  width = '15',
  height = '15'
}: SVGProps<SVGSVGElement>) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 15 15"
  >
    <path
      d="M7.501 0C5.35813 0 3.60645 1.75169 3.60645 3.89456C3.60645 6.03744 5.35813 7.78913 7.501 7.78913C9.64387 7.78913 11.3956 6.03744 11.3956 3.89456C11.3956 1.75169 9.64387 0 7.501 0Z"
      fill={fill}
    />
    <path
      d="M14.1847 10.9013C14.0827 10.6462 13.9467 10.4081 13.7936 10.187C13.0113 9.0305 11.8038 8.2652 10.4433 8.07812C10.2732 8.06113 10.0861 8.09512 9.95007 8.19717C9.23578 8.72438 8.38546 8.99648 7.50108 8.99648C6.61671 8.99648 5.76638 8.72438 5.05209 8.19717C4.91603 8.09512 4.72895 8.04411 4.5589 8.07812C3.19835 8.2652 1.97387 9.0305 1.20857 10.187C1.05551 10.4081 0.919443 10.6632 0.817424 10.9013C0.766415 11.0033 0.783407 11.1224 0.834416 11.2244C0.970484 11.4625 1.14054 11.7006 1.2936 11.9047C1.53168 12.2278 1.78679 12.5169 2.07592 12.789C2.31401 13.0271 2.58611 13.2482 2.85824 13.4693C4.20177 14.4727 5.81742 14.9999 7.48409 14.9999C9.15076 14.9999 10.7664 14.4727 12.1099 13.4693C12.382 13.2652 12.6541 13.0271 12.8923 12.789C13.1644 12.5169 13.4365 12.2278 13.6746 11.9047C13.8446 11.6836 13.9977 11.4625 14.1338 11.2244C14.2188 11.1224 14.2358 11.0033 14.1847 10.9013Z"
      fill={fill}
    />
  </svg>
);

export default UserIcon;
